/**
 * Feb 2026 R293zzc · Rich-text editor dialog for a single description.
 */
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import SmartRichText from "@/components/SmartRichText";

export default function LineRichTextDialog({ value, onSave, onClose }) {
  // Convert plain text (likely stored as such on legacy docs) into
  // minimal HTML so the editor shows the content and the user can
  // layer formatting on top.
  const seed = (() => {
    const v = value || "";
    if (!v) return "";
    if (/<[a-z]+[^>]*>/i.test(v)) return v;
    return v.split("\n").map((line) => `<p>${line.replace(/</g, "&lt;").replace(/>/g, "&gt;") || "<br/>"}</p>`).join("");
  })();
  const [html, setHtml] = useState(seed);

  return (
    <Dialog open onOpenChange={(v) => !v && onClose?.()}>
      <DialogContent className="max-w-3xl" data-testid="line-rich-dialog">
        <DialogHeader>
          <DialogTitle>Description</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-muted-foreground -mt-2 mb-2">
          Format bullets, bold, links or paste a block of details — it rides along onto the PDF and the preview.
        </p>
        <div className="border border-border rounded-md min-h-[220px] px-2 py-1">
          <SmartRichText
            value={html}
            onChange={setHtml}
            placeholder="Describe the line…"
            minRows={6}
            testid="line-rich-editor"
          />
        </div>
        <div className="flex items-center justify-end gap-2 pt-2">
          <Button variant="outline" size="sm" onClick={onClose} data-testid="line-rich-cancel">
            Cancel
          </Button>
          <Button size="sm" onClick={() => onSave?.(html)} data-testid="line-rich-save">
            Save description
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
